import React from 'react'
import { AvatarCompat } from 'components/shared/AvatarCompat'
import CompanyInfoField from './CompanyInfoField'
import { intComma } from 'humanize-plus'
import Icon from 'svg-inline-react'
import CompanyInfoProvider from "./CompanyInfoProvider"
import Social from "../../shared/ContactRecordLite/Social"

import DEFAULT_AVATAR from '!svg-inline?removeTags=true!images/live/default-company-logo.svg'
import './style.styl'
import ConditionalRender from 'components/shared/ConditionalRender'

const CompanyInfoModal = ({ companyInfo, canUseCompanyTags }) => {

  const location = _.get(companyInfo, 'location', '-')
  const category = _.get(companyInfo, 'category.industry', '-')
  const subCategory = _.get(companyInfo, 'category.subIndustry', '-') || '-'
  const linkedin = _.get(companyInfo, 'linkedin.handle')
  const employees = _.get(companyInfo, 'metrics.employees', '-')
  const raised = _.get(companyInfo, 'metrics.raised', '-')
  const twitter = _.get(companyInfo, 'twitter.handle',)
  const about = _.get(companyInfo, 'about', _.get(companyInfo, 'description', '-')) || '-'
  const tags = _.get(companyInfo, 'tags', [])
  const revenueRange = _.get(companyInfo, 'metrics.revenueRange', '-')
  const source = _.get(companyInfo, 'source')

  const companyLogo = (!!companyInfo.logo ?
      <AvatarCompat company={{ name: companyInfo.name, logo: companyInfo.logo }} type="company" size="small"/> :
      <div className="contact-info-header-logo">
        <Icon src={DEFAULT_AVATAR}/>
      </div>
  )
  const companyProvider = <CompanyInfoProvider provider={source}/>

  return (
    <div className="scrolly-content">
      <div className="company-info-header">
        <div className="company-info-header-left">
          {companyLogo}
        </div>
        <div className="company-info-header-right">
          <div className="company-info-title">{companyInfo.name}</div>
          <a href={companyInfo.url || `http://www.${companyInfo.domain}`} target="_blank" className="company-info-url"><span>{companyInfo.domain}</span></a>
          <div className="company-info-social">
            {!!twitter && <Social type="twitter" handle={twitter} className="company-info-social-icon"/>}
            {!!linkedin && <Social type="linkedin" handle={linkedin} className="company-info-social-icon"/>}
          </div>
        </div>
      </div>
      <div className="company-info-content">
        <div className="company-info-content-left">
          <CompanyInfoField primary={location} secondary="location"/>
          <CompanyInfoField primary={category} secondary="category"/>
          <CompanyInfoField primary={subCategory} secondary="subcategory"/>
          <ConditionalRender condition={canUseCompanyTags}>
            <CompanyInfoField primary={tags.join(', ')} secondary="tags" />
          </ConditionalRender>
        </div>

        <div className={"company-info-content-right"}>
          <CompanyInfoField primary={employees} secondary="employees"/>
          {source === 'DEMANDBASE' && <CompanyInfoField primary={revenueRange} secondary="revenue range"/>}
          {source === 'CLEARBIT' && <CompanyInfoField primary={`$${intComma(raised)}`} secondary="money raised"/>}
        </div>
        <div className="company-info-content-divider"/>
        <CompanyInfoField primary={about} secondary="about"/>
      </div>
      {!!companyProvider && (
        <div className="company-info-footer">
          {companyProvider}
        </div>
      )}
    </div>)
}


export default CompanyInfoModal



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/index.js